import { formatDistanceToNow, format } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Parse une date ISO string (UTC) et la convertit en Date locale.
 * Gère les formats: "2025-10-24T18:46:00" (sans Z) et "2025-10-24T18:46:00Z"
 */
export function parseUTCDate(dateString: string | Date): Date {
  if (dateString instanceof Date) {
    return dateString;
  }

  // Si la chaîne ne contient pas 'Z', ajouter 'Z' pour indiquer UTC
  const isoString = typeof dateString === 'string' && !dateString.endsWith('Z')
    ? `${dateString}Z`
    : dateString;

  return new Date(isoString);
}

/**
 * Formate une date relative (ex: "il y a 2 minutes") en français.
 * Gère correctement les timestamps UTC du backend.
 */
export function formatRelativeTime(dateString: string | Date): string {
  const date = parseUTCDate(dateString);
  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: fr,
  });
}

/**
 * Formate une date en format lisible (ex: "24 oct. 2025, 18:46").
 */
export function formatFullDateTime(dateString: string | Date): string {
  const date = parseUTCDate(dateString);
  return format(date, 'dd MMM yyyy, HH:mm', { locale: fr });
}

/**
 * Formate une date en format court (ex: "18:46").
 */
export function formatTime(dateString: string | Date): string {
  const date = parseUTCDate(dateString);
  return format(date, 'HH:mm', { locale: fr });
}

/**
 * Formate une date en format court avec date (ex: "24 oct, 18:46").
 */
export function formatShortDateTime(dateString: string | Date): string {
  const date = parseUTCDate(dateString);
  return format(date, 'dd MMM, HH:mm', { locale: fr });
}
